import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type SubscriptionInvoiceState = CommonTableState;

/** Sekce Faktury na admin dashboardu předplatných. Filtr období je sloupcový filtr invoiceIssueDate. */
const initialState: SubscriptionInvoiceState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "invoiceIssueDate", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: [
            "company.id",
            "invoiceIssueDate",
            "invoiceNumber",
            "amount",
            "paymentState",
            "dueDate",
            "periodStart",
            "periodEnd",
            "variableSymbol",
            "tariff.id",
            "orderNumber",
            "responsiblePerson.id",
            "licenceStatus",
            "mrt-row-actions",
        ],
        columnVisibility: {
            variableSymbol: false,
            "tariff.id": false,
            orderNumber: false,
            "responsiblePerson.id": false,
            licenceStatus: false,
        },
        density: "compact",
    },
};

export const subscriptionInvoiceSlice = createSlice({
    name: "subscriptionInvoice",
    initialState: initialState,
    reducers: {
        updateSubscriptionInvoiceTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

export const { updateSubscriptionInvoiceTableState } = subscriptionInvoiceSlice.actions;

export default subscriptionInvoiceSlice.reducer;
